
const ValidationStatusBadge = ({ status, size = 'normal' }) => {
  const statusConfig = {
    Pending: { 
      class: 'warning', 
      label: 'En Attente', 
      icon: 'fas fa-hourglass-split' 
    },
    Approved: { 
      class: 'success', 
      label: 'Approuvé', 
      icon: 'fas fa-check-circle' 
    },
    Rejected: { 
      class: 'danger', 
      label: 'Rejeté', 
      icon: 'fas fa-x-circle' 
    },
    FullyApproved: {
      class: 'success',
      label: 'Totalement Approuvé',
      icon: 'fas fa-check-all'
    },
    PartiallyApproved: {
      class: 'info',
      label: 'Partiellement Approuvé',
      icon: 'fas fa-check-circle'
    },
    PartiallyRejected: {
      class: 'warning',
      label: 'Partiellement Rejeté',
      icon: 'fas fa-exclamation-circle'
    },
    FullyRejected: {
      class: 'danger',
      label: 'Totalement Rejeté',
      icon: 'fas fa-x-circle'
    }
  };

  const config = statusConfig[status] || statusConfig.Pending;
  const sizeClass = size === 'small' ? 'badge-sm' : '';

  return (
    <span 
      className={`badge bg-${config.class} bg-opacity-10 text-${config.class} border border-${config.class} border-opacity-25 ${sizeClass}`}
      title={config.label}
    >
      <i className={`${config.icon} me-1`}></i>
      {config.label}
    </span>
  );
};

export default ValidationStatusBadge;